exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".partner-manage-container .partner-table-container[data-v-7745bea6] {\n  margin: 20px 0;\n}\n.partner-manage-container .pagination-container[data-v-7745bea6] {\n  margin-top: 20px;\n}\n", ""]);

// exports
